import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';
import {
    REINITIALIZE,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    FULL_NAME_SET_VALUE,
    FULL_NAME_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    TIN_NUMBER_SET_VALUE,
    TIN_NUMBER_SET_VALID,
    FORM_VALID_TRAVEL_INSURANCE_UG_TRAVEL_DETAILS_FORM,
    FORM_INVALID_TRAVEL_INSURANCE_UG_TRAVEL_DETAILS_FORM,
    COLLECT_TRAVEL_DETAILS_FORM_DATA,
    API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM,
    API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM,
    API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM,
    TRAVELLERS_SET_VALUE,
    TRAVELLER_SET_VALUE,
    UPDATE_TRAVELLER_VALUE,
    SUBMIT_TRAVEL_DETAILS_FAILURE,
    SUBMIT_TRAVEL_DETAILS_SUCCESS,
    SET_CURRENT_TRAVELLER_INDEX,
    SET_TRAVELLERS_ID_VALUE,
    NATIONALITY_TYPE_SET_VALUE,
    NATIONALITY_TYPE_SET_VALID,
    PASSPORT_NUMBER_SET_VALUE,
    PASSPORT_NUMBER_SET_VALID,
    PROFESSION_SET_VALUE,
    PROFESSION_SET_VALID,
    OFFICE_NUMBER_SET_VALUE,
    OFFICE_NUMBER_SET_VALID,
    TOWN_SET_VALUE,
    TOWN_SET_VALID,
    POSTAL_ADDRESS_SET_VALUE,
    POSTAL_ADDRESS_SET_VALID,
    BANK_NAME_SET_VALUE,
    BANK_NAME_SET_VALID,
    BANK_HOLDER_NAME_SET_VALUE,
    BANK_HOLDER_NAME_SET_VALID,
    BANK_ACCOUNT_NUMBER_SET_VALUE,
    BANK_ACCOUNT_NUMBER_SET_VALID,
    BANK_BRANCH_SET_VALUE,
    BANK_BRANCH_SET_VALID,
    BANK_ACCOUNT_CURRENCY_SET_VALUE,
    BANK_ACCOUNT_CURRENCY_SET_VALID,
    PASSPORT_BIODATA_SET_VALUE,
    PASSPORT_BIODATA_SET_VALID,
    PASSPORT_BIODATA_RESET_VALUE,
    ID_UPLOAD_SET_VALUE,
    ID_UPLOAD_SET_VALID,
    ID_UPLOAD_RESET_VALUE,
    SELECTED_FORM_SET_VALUE,
    CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS,
    EMERGENCY_CONTACT_FULL_NAME_VALUE,
    EMERGENCY_CONTACT_FULL_NAME_VALID,
    EMERGENCY_CONTACT_EMAIL_ADDRESS_VALUE,
    EMERGENCY_CONTACT_EMAIL_ADDRESS_VALID,
    EMERGENCY_CONTACT_PHONE_NUMBER_VALUE,
    EMERGENCY_CONTACT_PHONE_NUMBER_VALID,
    PASSPORT_DOCUMENT_ID_VALUE,
    PASSPORT_DOCUMENT_ID_VALID,
    ID_DOCUMENT_ID_VALUE,
    ID_DOCUMENT_ID_VALID,
    CUSTOMER_SET_VALUE,
    PERSONAL_DATA_PROCESSING_CONSENT_SET_VALUE,
    PERSONAL_DATA_PROCESSING_CONSENT_SET_VALID,
    CHILD_DATA_PROCESSING_CONSENT_SET_VALUE,
    CHILD_DATA_PROCESSING_CONSENT_SET_VALID,
    MARKETING_USE_CONSENT_SET_VALUE,
    MARKETING_USE_CONSENT_SET_VALID,
    FIRST_NAME_SET_VALUE,
    FIRST_NAME_SET_VALID,
    MIDDLE_NAME_SET_VALUE,
    MIDDLE_NAME_SET_VALID,
    LAST_NAME_SET_VALUE,
    LAST_NAME_SET_VALID,
    SET_PREVENT_USER_PROCEED,
    TRAVEL_DETAILS_SUBMITTED_SET_VALUE,
} from '../../actions/travelUg/travelDetails';

export const initTravelDetails = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    apiCallStatus: null,
    travellers: [],
    currentTravellerIndex: null,
    selectedForm: 'travelDetails',
    customer: {},
    blacklisted: {
        value: null,
        error: null,
        status: null,
    },
    preventUserProceed: false,
    travelDetailsSubmitted: false,
    form: {
        nationalityType: { value: 'Ugandan', error: null, status: FIELD_STATUS.VALID },
        idNumber: { value: null, error: null, status: null },
        passportNumber: { value: null, error: null, status: null },
        tinNumber: { value: null, error: null, status: null },
        fullName: { value: null, error: null, status: null },
        firstName: { value: null, error: null, status: null },
        middleName: { value: null, error: null, status: null },
        lastName: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        travellerId: { value: null, error: null, status: null },
        profession: { value: null, error: null, status: null },
        officeNumber: { value: null, error: null, status: null },
        town: { value: null, error: null, status: null },
        postalAddress: { value: null, error: null, status: null },
        bankName: { value: null, error: null, status: null },
        bankHolderName: { value: null, error: null, status: null },
        bankAccountNumber: { value: null, error: null, status: null },
        bankBranch: { value: null, error: null, status: null },
        bankAccountCurrency: { value: null, error: null, status: null },
        passportBiodata: { value: null, error: null, status: null },
        passportDocumentId: { value: null, error: null, status: null },
        idUpload: { value: null, error: null, status: null },
        idDocumentId: { value: null, error: null, status: null },
        emergencyContactFullName: { value: null, error: null, status: null },
        emergencyContactEmailAddress: { value: null, error: null, status: null },
        emergencyContactPhoneNumber: { value: null, error: null, status: null },
        personalDataProcessingConsent: { value: false, error: null, status: null },
        childDataProcessingConsent: { value: false, error: null, status: null },
        marketingUseConsent: { value: false, error: null, status: null },
    },
};

export default (state = initTravelDetails, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_TRAVEL_INSURANCE_UG_TRAVEL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_TRAVEL_INSURANCE_UG_TRAVEL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case TRAVELLERS_SET_VALUE:
            return { ...state, travellers: action.value };

        case SET_CURRENT_TRAVELLER_INDEX:
            //console.log('Setting currentTravellerIndex to', action.value);
            return { ...state, currentTravellerIndex: action.value };

        case TRAVELLER_SET_VALUE:
            return { ...state, travellers: [...state.travellers, action.value] };

        case CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS:
            return {
                ...state,
                blacklisted: {
                    ...state.blacklisted,
                    value: action.value,
                    status: API_CALL_STATUS.SUCCESS,
                },
            };

        case TRAVEL_DETAILS_SUBMITTED_SET_VALUE:
            return {
                ...state,
                travelDetailsSubmitted: action.value,
            };

        case SET_PREVENT_USER_PROCEED:
            return {
                ...state,
                preventUserProceed: action.value,
            };

        case CUSTOMER_SET_VALUE:
            return {
                ...state,
                customer: action.value,
            };

        case SELECTED_FORM_SET_VALUE:
            return { ...state, selectedForm: action.value };

        case UPDATE_TRAVELLER_VALUE:
            let index = state?.travellers
                .map(function (traveller) {
                    return traveller.travellerId.value;
                })
                .indexOf(action.id);

            let updatedTravellers = state?.travellers;
            updatedTravellers[index] = action.value;
            return { ...state, travellers: updatedTravellers };

        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SET_TRAVELLERS_ID_VALUE:
            return updateFormField('travellerId', (field) => ({
                ...field,
                value: action.value,
            }));

        case NATIONALITY_TYPE_SET_VALUE:
            return updateFormField('nationalityType', (field) => ({
                ...field,
                value: action.value,
            }));
        case NATIONALITY_TYPE_SET_VALID:
            return updateFormField('nationalityType', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_NUMBER_SET_VALUE:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case PASSPORT_NUMBER_SET_VALID:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TIN_NUMBER_SET_VALUE:
            return updateFormField('tinNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case TIN_NUMBER_SET_VALID:
            return updateFormField('tinNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PROFESSION_SET_VALUE:
            return updateFormField('profession', (field) => ({
                ...field,
                value: action.value,
            }));
        case PROFESSION_SET_VALID:
            return updateFormField('profession', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case PHONE_NUMBER_SET_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case OFFICE_NUMBER_SET_VALUE:
            return updateFormField('officeNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case OFFICE_NUMBER_SET_VALID:
            return updateFormField('officeNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case POSTAL_ADDRESS_SET_VALUE:
            return updateFormField('postalAddress', (field) => ({
                ...field,
                value: action.value,
            }));
        case POSTAL_ADDRESS_SET_VALID:
            return updateFormField('postalAddress', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case TOWN_SET_VALUE:
            return updateFormField('town', (field) => ({
                ...field,
                value: action.value,
            }));
        case TOWN_SET_VALID:
            return updateFormField('town', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case BANK_NAME_SET_VALUE:
            return updateFormField('bankName', (field) => ({
                ...field,
                value: action.value,
            }));
        case BANK_NAME_SET_VALID:
            return updateFormField('bankName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case BANK_HOLDER_NAME_SET_VALUE:
            return updateFormField('bankHolderName', (field) => ({
                ...field,
                value: action.value,
            }));
        case BANK_HOLDER_NAME_SET_VALID:
            return updateFormField('bankHolderName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case BANK_ACCOUNT_NUMBER_SET_VALUE:
            return updateFormField('bankAccountNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case BANK_ACCOUNT_NUMBER_SET_VALID:
            return updateFormField('bankAccountNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case BANK_BRANCH_SET_VALUE:
            return updateFormField('bankBranch', (field) => ({
                ...field,
                value: action.value,
            }));
        case BANK_BRANCH_SET_VALID:
            return updateFormField('bankBranch', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case BANK_ACCOUNT_CURRENCY_SET_VALUE:
            return updateFormField('bankAccountCurrency', (field) => ({
                ...field,
                value: action.value,
            }));
        case BANK_ACCOUNT_CURRENCY_SET_VALID:
            return updateFormField('bankAccountCurrency', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        //emergency contact details
        case EMERGENCY_CONTACT_FULL_NAME_VALUE:
            return updateFormField('emergencyContactFullName', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMERGENCY_CONTACT_FULL_NAME_VALID:
            return updateFormField('emergencyContactFullName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMERGENCY_CONTACT_EMAIL_ADDRESS_VALUE:
            return updateFormField('emergencyContactEmailAddress', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMERGENCY_CONTACT_EMAIL_ADDRESS_VALID:
            return updateFormField('emergencyContactEmailAddress', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMERGENCY_CONTACT_PHONE_NUMBER_VALUE:
            return updateFormField('emergencyContactPhoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMERGENCY_CONTACT_PHONE_NUMBER_VALID:
            return updateFormField('emergencyContactPhoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_BIODATA_SET_VALUE:
            return updateFormField('passportBiodata', (field) => ({
                ...field,
                value: action.value,
            }));
        case PASSPORT_BIODATA_SET_VALID:
            return updateFormField('passportBiodata', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case PASSPORT_BIODATA_RESET_VALUE:
            return updateFormField('passportBiodata', (field) => ({
                ...field,
                value: null,
            }));

        case PASSPORT_DOCUMENT_ID_VALUE:
            return updateFormField('passportDocumentId', (field) => ({
                ...field,
                value: action.value,
            }));
        case PASSPORT_DOCUMENT_ID_VALID:
            return updateFormField('passportDocumentId', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_DOCUMENT_ID_VALUE:
            return updateFormField('idDocumentId', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_DOCUMENT_ID_VALID:
            return updateFormField('idDocumentId', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_UPLOAD_SET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_UPLOAD_SET_VALID:
            return updateFormField('idUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case ID_UPLOAD_RESET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: null,
            }));

        case FULL_NAME_SET_VALUE:
            return updateFormField('fullName', (field) => ({
                ...field,
                value: action.value,
            }));
        case FULL_NAME_SET_VALID:
            return updateFormField('fullName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FIRST_NAME_SET_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));
        case FIRST_NAME_SET_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MIDDLE_NAME_SET_VALUE:
            return updateFormField('middleName', (field) => ({
                ...field,
                value: action.value,
            }));
        case MIDDLE_NAME_SET_VALID:
            return updateFormField('middleName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case LAST_NAME_SET_VALUE:
            return updateFormField('lastName', (field) => ({
                ...field,
                value: action.value,
            }));
        case LAST_NAME_SET_VALID:
            return updateFormField('lastName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PERSONAL_DATA_PROCESSING_CONSENT_SET_VALUE:
            return updateFormField('personalDataProcessingConsent', (field) => ({
                ...field,
                value: action.value,
            }));

        case PERSONAL_DATA_PROCESSING_CONSENT_SET_VALID:
            return updateFormField('personalDataProcessingConsent', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case CHILD_DATA_PROCESSING_CONSENT_SET_VALUE:
            return updateFormField('childDataProcessingConsent', (field) => ({
                ...field,
                value: action.value,
            }));

        case CHILD_DATA_PROCESSING_CONSENT_SET_VALID:
            return updateFormField('childDataProcessingConsent', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MARKETING_USE_CONSENT_SET_VALUE:
            return updateFormField('marketingUseConsent', (field) => ({
                ...field,
                value: action.value,
            }));

        case MARKETING_USE_CONSENT_SET_VALID:
            return updateFormField('marketingUseConsent', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        //    API Calls
        case API_PENDING_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_TRAVEL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        // Submit user data
        case COLLECT_TRAVEL_DETAILS_FORM_DATA:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case SUBMIT_TRAVEL_DETAILS_SUCCESS:
            return { ...state, personalDetailsReferenceData: action.value };
        case SUBMIT_TRAVEL_DETAILS_FAILURE:
            return { ...state, personalDetailsReferenceData: action.error };

        // Reset the state
        case REINITIALIZE:
            return initTravelDetails;
        default:
            return state;
    }
};
